module.exports = __webpack_public_path__ + "static/media/texasMentalHealth.295f2bfe.jpg";